import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Users/xnng/code/sre/official/official_website/layouts/default.vue").then(m => m.default || m))
}